import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Dropdown, Button, Menu } from "antd";
import {
	SunOutlined,
	MoonOutlined,
	CheckOutlined,
	DownOutlined,
	HighlightOutlined,
} from "@ant-design/icons";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { onSwitchTheme } from "redux/actions/Theme";
import { getCssSwitcherKey, THEME_KEYS } from "utils/themeDisplay";

const THEMES = [
	{ value: THEME_KEYS.LIGHT, label: "Claro", icon: SunOutlined },
	{ value: THEME_KEYS.DARK, label: "Escuro", icon: MoonOutlined },
	{
		value: THEME_KEYS.QUESTOR,
		label: "Questor",
		icon: HighlightOutlined,
	},
];

function ThemeToggleContent({
	currentTheme,
	onSwitchTheme: onSwitchThemeProp,
	compact,
}) {
	const [visible, setVisible] = useState(false);
	const isMounted = useRef(true);
	const { switcher, themes } = useThemeSwitcher();

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	const current = THEMES.find((t) => t.value === currentTheme) || THEMES[0];
	const CurrentIcon = current.icon;

	const applyTheme = (key) => {
		onSwitchThemeProp(key);
		switcher({ theme: themes[getCssSwitcherKey(key)] });
		if (isMounted.current) setVisible(false);
	};

	const handleSelect = ({ key }) => {
		applyTheme(key);
	};

	const onVisibleChange = (v) => {
		if (isMounted.current) setVisible(v);
	};

	const menuItems = THEMES.map((t) => {
		const IconComponent = t.icon;
		const selected = currentTheme === t.value;
		return {
			key: t.value,
			label: (
				<span className="d-flex align-items-center">
					<IconComponent className="mr-2" />
					{t.label}
					{selected && (
						<CheckOutlined
							className="ml-auto"
							style={{
								color:
									t.value === THEME_KEYS.QUESTOR
										? "#e87722"
										: "#1bae72",
							}}
						/>
					)}
				</span>
			),
		};
	});

	const menu = (
		<Menu
			selectedKeys={[currentTheme]}
			onClick={handleSelect}
			items={menuItems}
		/>
	);

	const triggerButton = (
		<Button
			type="text"
			className={
				compact
					? `header-nav-tool-btn d-flex align-items-center justify-content-center ${
							currentTheme === THEME_KEYS.DARK
								? "header-nav-tool-btn--dark"
								: "header-nav-tool-btn--light"
						}`
					: "d-flex align-items-center justify-content-center"
			}
			style={{ color: "inherit" }}
			aria-haspopup="menu"
			aria-expanded={visible}
			aria-label="Modo de exibição"
		>
			<span className="d-inline-flex align-items-center" style={{ gap: 4 }}>
				<CurrentIcon className={compact ? "" : "font-size-lg"} />
				<DownOutlined style={{ fontSize: compact ? 10 : 11, opacity: 0.75 }} />
			</span>
		</Button>
	);

	return (
		<Dropdown
			visible={visible}
			onVisibleChange={onVisibleChange}
			overlay={menu}
			trigger={["click"]}
			placement="bottomRight"
		>
			{triggerButton}
		</Dropdown>
	);
}

const mapStateToProps = ({ theme }) => ({
	currentTheme: theme.currentTheme,
});

export default connect(mapStateToProps, { onSwitchTheme })(ThemeToggleContent);
